export default __webpack_public_path__ + "static/media/(41).54187783.jpg";